function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 3c0-1.656-1.159-3-3-3s-3 1.344-3 3H8v1H5a1 1 0 00-1 1v24a1 1 0 001 1h20a1 1 0 001-1V5a1 1 0 00-1-1h-3V3h-4zm-2 0a1 1 0 11-2 0 1 1 0 012 0zM6 29a1 1 0 01-1-1V7a1 1 0 011-1h18a1 1 0 011 1v21a1 1 0 01-1 1H6zm9-16.667c-.377 0-.682.392-.682.875s.305.875.682.875c.376 0 .682-.392.682-.875s-.306-.875-.682-.875zM12.545 20.5l-1.09 3.5h.543l1.366-2.917L15 19.333l1.637 1.75L18.002 24h.544l-1.091-3.5-1.364-2.917.273-1.75 1.09-4.083h.273v-.583h-5.454v.583h.272l1.091 4.083.273 1.75-1.364 2.917zm1.91-5.834L13.09 11.75h3.818l-1.363 2.916h-1.091zm-4.364-2.333H9v-1.75h1.09v1.75zm1.636.584h-1.09V10h1.09v2.917zM21 12.333h-1.09v-1.75H21v1.75zm-1.636.584h-1.091V10h1.09v2.917z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "4",
  y: "0",
  width: "22",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 3c0-1.656-1.159-3-3-3s-3 1.344-3 3H8v1H5a1 1 0 00-1 1v24a1 1 0 001 1h20a1 1 0 001-1V5a1 1 0 00-1-1h-3V3h-4zm-2 0a1 1 0 11-2 0 1 1 0 012 0zM6 29a1 1 0 01-1-1V7a1 1 0 011-1h18a1 1 0 011 1v21a1 1 0 01-1 1H6zm9-16.667c-.377 0-.682.392-.682.875s.305.875.682.875c.376 0 .682-.392.682-.875s-.306-.875-.682-.875zM12.545 20.5l-1.09 3.5h.543l1.366-2.917L15 19.333l1.637 1.75L18.002 24h.544l-1.091-3.5-1.364-2.917.273-1.75 1.09-4.083h.273v-.583h-5.454v.583h.272l1.091 4.083.273 1.75-1.364 2.917zm1.91-5.834L13.09 11.75h3.818l-1.363 2.916h-1.091zm-4.364-2.333H9v-1.75h1.09v1.75zm1.636.584h-1.09V10h1.09v2.917zM21 12.333h-1.09v-1.75H21v1.75zm-1.636.584h-1.091V10h1.09v2.917z",
  fill: "currentColor"
}))));